import { render, staticRenderFns } from "./DashboardProformaInvoice.vue?vue&type=template&id=52b92744"
import script from "./DashboardProformaInvoice.vue?vue&type=script&lang=js"
export * from "./DashboardProformaInvoice.vue?vue&type=script&lang=js"
import style0 from "./DashboardProformaInvoice.vue?vue&type=style&index=0&id=52b92744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports